module.exports = __webpack_public_path__ + "media/images/feedback-c25f571c63496f6df608d3e0d61a7fcf.png";